class BeforeAfterSlider extends HTMLElement {
  connectedCallback() {
    this._before = this.querySelector(".before-image");
    this._beforeImg = this._before.querySelector("img");
    this._resizer = this.querySelector(".resizer");
    this._active = false;

    this._syncSize();
    this._resizeObserver = new ResizeObserver(() => this._syncSize());
    this._resizeObserver.observe(this);

    this._resizer.addEventListener("mousedown", () => this._startDrag());
    this._resizer.addEventListener("touchstart", () => this._startDrag(), {
      passive: true,
    });

    document.addEventListener("mouseup", () => this._stopDrag());
    document.addEventListener("mouseleave", () => this._stopDrag());
    document.addEventListener("touchend", () => this._stopDrag());
    document.addEventListener("touchcancel", () => this._stopDrag());

    document.addEventListener("mousemove", (e) => {
      if (!this._active) return;
      e.preventDefault();
      this._slide(e.pageX);
    });

    document.addEventListener(
      "touchmove",
      (e) => {
        if (!this._active) return;
        e.preventDefault();
        this._slide(e.changedTouches[e.changedTouches.length - 1].pageX);
      },
      { passive: false },
    );
  }

  disconnectedCallback() {
    if (this._resizeObserver) this._resizeObserver.disconnect();
  }

  _startDrag() {
    this._active = true;
    this._resizer.classList.add("resize");
  }

  _stopDrag() {
    this._active = false;
    this._resizer.classList.remove("resize");
  }

  _syncSize() {
    this._beforeImg.style.width = this.offsetWidth + "px";
  }

  _slide(pageX) {
    const x = pageX - this.getBoundingClientRect().left;
    const clamped = Math.max(0, Math.min(x, this.offsetWidth));
    this._before.style.width = clamped + "px";
    this._resizer.style.left = clamped + "px";
  }
}

customElements.define("before-after-slider", BeforeAfterSlider);

class BaSlideTab extends HTMLElement {
  connectedCallback() {
    this.tabs = this.querySelectorAll(".toggle-accordion");
    this.targets = this.querySelectorAll(".slideContents");
    this.tabs.forEach((tab) =>
      tab.addEventListener("click", this.#toggleTab.bind(this)),
    );
  }

  #toggleTab(e) {
    const index = e.currentTarget.dataset.index;
    this.#closeAll(index);
    // this.tabs.forEach(tab => tab.classList.toggle('active', tab.dataset.index === index));
    this.targets.forEach((target) =>
      target.classList.toggle("hidden", target.dataset.index !== index),
    );
  }

  #closeAll(index) {
    this.tabs.forEach((tab, idx) => {
      const item = tab.closest("thc-accordion-banner");
      if (index.toString() !== idx.toString()) item.close();
    });
  }
}
customElements.define("ba-slide-tab", BaSlideTab);
